<template>
  <b-form @submit.stop.prevent="onSearch">
    <b-input-group>
      <b-form-input
        placeholder="Search by $ticker, @user, #keyword..."
        type="search"
        trim
        v-model="query"
      ></b-form-input>
      <b-input-group-append>
        <b-button type="submit" variant="outline-primary">Search</b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    query: "",
  }),
  computed: {
    searchRouteName() {
      if (this.$route.name.toLowerCase().startsWith("search")) {
        return this.$route.name;
      }
      return "Search";
    },
  },
  methods: {
    mergeQuery(query) {
      return Object.assign({}, this.$route.query, query);
    },
    onSearch() {
      this.$router.push({
        name: this.searchRouteName,
        query: this.mergeQuery({
          p: 1,
          q: this.query,
          t: new Date().getTime(),
        }),
      });
    },
  },
  watch: {
    value(val) {
      this.query = val;
    },
  },
  mounted() {
    this.query = this.value;
  },
};
</script>
